import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = false

const sideBarSlice = createSlice({
    name: 'sideBarSlice',
    initialState,
    reducers: {
        toggleSideBar: (state, action: PayloadAction<boolean>) => {
            state = action.payload
            return state
        },
    },
})

export const { actions: sideBarActions } = sideBarSlice
export const { reducer: sideBarReducer } = sideBarSlice
